import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { useMaskPII } from 'hooks/useMaskPII';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import {
  resetDirectDebitErrors,
  setDirectDebitField
} from 'state/direct-debit/direct-debit-slice';

export const testID = 'DirectDebitPlaybackTestId';

type DirectDebitPlayBackProps = {
  details: {
    firstName?: string;
    lastName?: string;
    birthDate?: string;
    paymentDate?: string;
    sortCode?: string;
    accountNumber?: string;
    address: {
      flatNumber?: string;
      houseNumber?: string;
      houseName?: string;
      addressLine1?: string;
      addressLine2?: string;
      postalTown?: string;
      county?: string;
      displayName?: string;
      postcode?: string;
    };
  };
};

export const DirectDebitPlayBack = ({ details }: DirectDebitPlayBackProps) => {
  const { mask } = useMaskPII();
  const dispatch = useDispatch();

  const {
    firstName,
    lastName,
    birthDate,
    paymentDate,
    sortCode,
    accountNumber,
    address
  } = details;

  const { postcode = '' } = address;

  const formattedPaymentDate = moment()
    .localeData()
    .ordinal(parseInt(paymentDate || '0'));

  const handleEditClick = useCallback(() => {
    dispatch(resetDirectDebitErrors());
    dispatch(setDirectDebitField({ name: 'isCommercial', value: false }));
  }, [dispatch]);

  return (
    <div data-testid={testID}>
      <NsDescriptionList>
        {[
          {
            term: 'First name',
            description: <p {...mask}>{firstName}</p>
          },
          {
            term: 'Last name',
            description: <p {...mask}>{lastName}</p>
          },
          {
            term: 'Date of birth',
            description: <p>{birthDate}</p>
          },
          {
            term: 'Sort code',
            description: <p {...mask}>{sortCode}</p>
          },
          {
            term: 'Account number',
            description: <p {...mask}>{accountNumber}</p>
          },
          {
            term: 'Address',
            description: (
              <p {...mask}>
                {address?.displayName}, {postcode}
              </p>
            )
          },
          {
            term: 'Payment date',
            description: <p>{formattedPaymentDate} of every month</p>
          }
        ]}
      </NsDescriptionList>
      <NsSecondaryCta onClick={handleEditClick}>
        Edit your payment details
      </NsSecondaryCta>
    </div>
  );
};
